import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggleButton"]

  connect() {
    this.visible = this.data.has("visible") ? this.data.get("visible") === "true" : false
    this.updateVisibility()
  }

  toggle() {
    this.visible = !this.visible
    this.updateVisibility()
  }

  updateVisibility() {
    if (this.hasContentTarget) {
      if (this.visible) {
        this.contentTarget.classList.remove('hidden')
      } else {
        this.contentTarget.classList.add('hidden')
      }
    }
  }
}
